import React from 'react';
import { Box, Typography } from '@mui/material';

const listItemStyle = {
  marginBottom: '0.75rem',
};

const UsagePolicySection = () => {
  return (
    <Box sx={{ px: { xs: 2, sm: 4 }, py: 2 }}>
      <Typography paragraph>
        WatchNod maintains strict usage policies to protect users and platform integrity.
      </Typography>

      {/* 1. Unauthorized Activities */}
      <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
        1. Unauthorized Activities
      </Typography>
      <ul style={{ paddingLeft: '1.25rem' }}>
        <li style={listItemStyle}>
          <Typography variant="body1">
            WatchNod reserves the right to detect, block, or suspend users who engage in unauthorized or malicious activities within the platform.
          </Typography>
        </li>
        <li style={listItemStyle}>
          <Typography variant="body1">
            Full blocking rights are exercised without prior notice in such cases.
          </Typography>
        </li>
      </ul>

      {/* 2. AutoPay Authorization */}
      <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
        2. AutoPay Authorization
      </Typography>
      <ul style={{ paddingLeft: '1.25rem' }}>
        <li style={listItemStyle}>
          <Typography variant="body1">
            When users enable AutoPay, they authorize WatchNod to automatically deduct funds from their wallet for subscription renewals.
          </Typography>
        </li>
        <li style={listItemStyle}>
          <Typography variant="body1">
            Users retain full control over enabling or disabling AutoPay through the Wallet Page.
          </Typography>
        </li>
        <li style={listItemStyle}>
          <Typography variant="body1">
            All AutoPay transactions are transparently recorded in the transaction history.
          </Typography>
        </li>
      </ul>

      {/* 3. Subscription Deletion Policy */}
      <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
        3. Subscription Deletion Policy
      </Typography>
      <ul style={{ paddingLeft: '1.25rem' }}>
        <li style={listItemStyle}>
          <Typography variant="body1">
            Subscriptions that are canceled manually or terminated by WatchNod are permanently deleted.
          </Typography>
        </li>
        <li style={listItemStyle}>
          <Typography variant="body1">
            <strong>Non-refundable:</strong> Canceled or deleted plans are not eligible for refunds.
          </Typography>
        </li>
        <li style={listItemStyle}>
          <Typography variant="body1">
            All associated data is erased and cannot be restored later.
          </Typography>
        </li>
      </ul>

      {/* 4. Referral Bonus Policy */}
      <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
        4. Referral Bonus Policy
      </Typography>
      <ul style={{ paddingLeft: '1.25rem' }}>
        <li style={listItemStyle}>
          <Typography variant="body1">
            <strong>Referral Program:</strong> Registered users can share their unique promo code with others to invite them to join WatchNod.
          </Typography>
        </li>
        <li style={listItemStyle}>
          <Typography variant="body1">
            <strong>Referral Code Usage:</strong> When a new user signs up and enters a valid referral code during registration, a $5 credit is automatically added to the referrer’s WatchNod account.
          </Typography>
        </li>
        <li style={listItemStyle}>
          <Typography variant="body1">
            <strong>Eligibility:</strong> The referral bonus is only credited if the new user completes the sign-up process using the promo code during account creation.
          </Typography>
        </li>
        <li style={listItemStyle}>
          <Typography variant="body1">
            <strong>Credit Usage:</strong> Referral bonuses are non-transferable and can only be used within the WatchNod platform for purchasing plans or services.
          </Typography>
        </li>
      </ul>

    </Box>
  );
};

export default UsagePolicySection;
